const interstitialSizes = [
  { width: 1080, height: 1920 },
  { width: 320, height: 480 }
];

export const isInterstitial = (width: number, height: number): boolean => {
  return interstitialSizes.some(
    size => size.width === width && size.height === height
  );
};